import * as React from 'react';
import classNames from 'classnames';
import { ExtraLargeImageContext } from '../../../common/ContentfulImage/ExtraLargeImageContext.esm.js';
import { SmallImageContext } from '../../../common/ContentfulImage/SmallImageContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './SectionImageWrapper.module.esm.js';

var SectionImageWrapper = function (_a) {
    var _b;
    var smallImage = _a.smallImage, image = _a.image;
    return (React.createElement(React.Fragment, null,
        React.createElement(ExtraLargeImageContext, null,
            React.createElement(BaseNucleobaseComponent, { alt: "", classes: { picture: classNames(styles.picture, (_b = {}, _b[styles.bigPicture] = smallImage, _b)) }, source: image })),
        smallImage && (React.createElement(SmallImageContext, null,
            React.createElement(BaseNucleobaseComponent, { alt: "", classes: { picture: classNames(styles.picture, styles.smallPicture) }, source: smallImage })))));
};

export { SectionImageWrapper as default };
//# sourceMappingURL=SectionImageWrapper.esm.js.map
